import type { SidePanel } from '../types';

export const SettingAutoWallet: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./SettingAutoWalletPanel.vue')),
};
